import { Entity } from "../../types/store.types";
import { LoadersMethods } from "./loaders.methods";

export type LoadersState = {
  isLoading: boolean;
};

export interface IReducerAction {
  type: LoadersMethods;
  payload?: {
    entities?: Entity<boolean>;
  };
}

let initialState: LoadersState = {
  isLoading: false
};

export const loadersReducer = 
<TAction extends IReducerAction>(
  state = initialState, action: TAction, entityName: string
) => {
  switch(action.type) {
    case LoadersMethods.UpdateLoader: {
      if (!action.payload || !action.payload.entities) break;
      const entities = action.payload.entities;
      if (!(entityName in entities)) break;
      state = {
        isLoading: entities[entityName]
      }
      break;
    }
    case LoadersMethods.ResetLoader: {
      if (!action.payload || !action.payload.entities) break;
      const entities = action.payload.entities;
      if (!(entityName in entities)) break;
      state = {
        isLoading: false
      };
      break;
    }
  }
  return state;
}
